import React from "react";
import CateringItemCard from "./CateringItemCard";
import { useDispatch, useSelector } from "react-redux";


import {
  updateCateringSelection
} from "../../../store/checkoutSlice";

const CateringProviderCard = ({ provider, eventId,isOrders,isCheckout }) => {


  const dispatch = useDispatch();


  return (
    <div className="card">

      <div className="header">
        <h4>
          {provider.first_name} {provider.last_name}
        </h4>

        {provider.paid_amount > 0 && (
          <span style={{ color: "green" }}>
            Paid ₹{provider.paid_amount}
          </span>
        )}

        {!isOrders && !provider.is_checked_out && provider.paid_amount === 0 && (
          <button
            onClick={() => {
              if (!window.confirm("Remove provider?")) return;
              dispatch(updateCateringSelection({ eventId, percentage: null }))
            }}
          >
            ❌
          </button>
        )}

      </div>

      {provider.items?.map((item) => (
        <CateringItemCard
          key={item.item_id}
          item={item}
          eventId={eventId}
          provider={provider}
          isCheckout={isCheckout}
        />
      ))}
    </div>
  );
};


export default CateringProviderCard;